import { supabase } from '../supabaseClient'

class ProfileService {
  getPaginatedProfiles = async (page: number, term?: string): Promise<any> => {
    try {
      const count = await this.countProfiles()
      let query = supabase
        .from('profiles')
        .select()
        .range((page - 1) * 5, page * 5)

      if (term) {
        query = query.ilike('profile_name', `%${term}%`)
      }

      const { data, error } = await query

      if (error) {
        console.error('Error fetching paginated Profiles:', error)
      }

      return {
        data: data || [],
        count,
      }
    } catch (error) {
      console.error('Error in paginated Profiles:', { error })
    }
  }

  countProfiles = async (): Promise<any> => {
    try {
      const { data, error } = await supabase.from('profiles').select('id')

      if (error) {
        console.error('Error fetching total profile count:', error)
      } else {
        return data?.length
      }
    } catch (e) {
      console.error('Error counting Profiles:', e)
    }
  }

  getProfileById = async (id: string): Promise<any> => {
    try {
      const { data, error } = await supabase.from('profiles').select('*').eq('id', id).single()

      if (error) {
        console.error('Error fetching profile by ID:', error)
      }

      return data
    } catch (error) {
      console.error('Error fetching profile by ID:', { error })
    }
  }
}

const profileService = new ProfileService()

export default profileService
